<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-slide-x-reverse-transition>
        <v-alert
          type="error"
          class="alert_all_page"
          v-if="alert_error === true"
          >{{ alert_message_error }}</v-alert
        >
        <v-alert
          type="success"
          class="alert_all_page"
          v-if="alert_success === true"
          >{{ alert_message_success }}</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">นับสต๊อก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="pa-3">
            <v-form ref="setting" @submit.prevent="saveData()">
              <v-row class="pa-3">
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">นับสต๊อก</div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row class="pa-3 pt-0">
                <v-col cols="12 pl-3">
                  <div class="font-16 font-bold">ค้นหาสินค้า</div>
                </v-col>

                <!-- <div class="text_title d-flex justify-space-between mt-3">
                    </div> -->
                <v-col cols="12" class="pa-3 py-0 pb-2">
                  <div class="text_title mt-2">
                    เลขบาร์โค้ด / ชื่อสินค้า <span class="red--text">*</span>
                  </div>
                  <div class="mt-2">
                    <v-autocomplete
                      ref="barcodeInput"
                      autofocus="true"
                      class="input-radius"
                      @change="getDetail()"
                      color="#D6BFAF"
                      :items="bacode_list"
                      item-text="search_product"
                      item-value="product_barcode"
                      v-model="product_barcode"
                      prepend-inner-icon="mdi-barcode-scan"
                      label="กรุณากรอกเลขบาร์โค้ด"
                      hide-details="auto"
                      outlined
                      dense
                      @keydown.enter.prevent="selectProduct"
                      clearable  
                    ></v-autocomplete>
                  </div>
                </v-col>
<!-- 
                <v-col cols="12 pl-3 pt-5">
                  <div class="font-16 font-bold">ข้อมูลสินค้า</div>
                </v-col> -->

                <!-- <v-col>
                  <div class="mr-0">
                    <v-img
                      v-if="list.picture"
                      height="180"
                      width="180"
                      lazy-src="@/assets/arin_assets/image_sun_color.png"
                      :src="list.picture"
                    ></v-img>
                    <v-img
                      v-else
                      class="preview"
                      height="180"
                      width="180"
                      lazy-src="@/assets/arin_assets/image_sun_color.png"
                      src="@/assets/arin_assets/image_sun_color.png"
                    ></v-img>
                  </div>
                </v-col> -->
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <div class="ml-3 d-flex flex-column justify-center">
                    <!-- <div class="text_header_title">ชื่อสินค้า / หน่วยนับ</div> -->
                    <div class="text_title mt-2">
                      จำนวนที่นับได้ <span class="red--text">*</span>
                    </div>
                    <div class="mt-2">
                      <v-text-field
                        ref="quantityInput"
                        type="number"
                        color="#D6BFAF"
                        class="input-radius"
                        v-model="quantity"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'กรุณาป้อนข้อมูล']"
                        required
                        placeholder="กรุณากรอกจำนวนที่นับได้"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="4" xl="4" cols="12"></v-col>

                <!-- <div class="text_title">หมายเหตุ</div>
                        <div class="mt-2">
                            <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" required placeholder="กรุณากรอกหมายเหตุ" outlined dense></v-text-field>
                        </div> -->
              </v-row>
              <div class="text-center mt-6 mb-3">
                <v-btn
                  type="submit"
                  height="45"
                  class="white--text grad-success-arin-bg mobile_btn"
                  style="font-size: 18px; border-radius: 10px"
                  >บันทึก</v-btn
                >
              </div>
            </v-form>
          </section>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "stock_count",
  data() {
    return {
      loading_page: false,
      alert_error: false,
      alert_message_error: null,
      alert_success: false,
      alert_message_success: null,
      page_number: 1,
      search: "",
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "นับสต๊อก",
          disabled: false,
          href: "#",
        },
      ],
      menu_date: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateEN: "",
      bacode_list: [],
      product_barcode: null,
      list: {},
    };
  },
  methods: {
    selectProduct() {
    // ตรวจสอบว่ามีค่าที่พิมพ์ในช่อง autocomplete
    if (!this.product_barcode) return;

    // ค้นหาสินค้าที่มีบาร์โค้ดตรงกัน
    const foundProduct = this.bacode_list.find(
      (item) => item.product_barcode === this.product_barcode
    );

    if (foundProduct) {
      // ✅ กำหนดค่าให้ autocomplete ทันที
      this.selectedProduct = foundProduct;

      // ✅ โฟกัสไปที่ช่องจำนวน
      this.$nextTick(() => {
        if (this.$refs.quantityInput) {
          this.$refs.quantityInput.focus();
        }
      });
    }
  },
    async getProductToSelectBox() {
      this.loading_page = true;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/countstock/store/get/product/list", config).then(
        (res) => {
          if (res.data.successful === true) {
            this.bacode_list = res.data.message;
            this.loading_page = false;
          }
        }
      );
    },
    getDetail() {
      this.list = this.bacode_list.find(
        (item) => item.product_barcode === this.product_barcode
      );
      this.$nextTick(() => {
        if (this.$refs.quantityInput) {
          this.$refs.quantityInput.focus();
        }
      });
    },
    async saveData() {
      if (this.$refs.setting.validate()) {
        let data = {
          count_stock_store_id: this.list.count_stock_store_id,
          product_barcode: this.list.product_barcode,
          product_id: this.list.product_id,
          product_code: this.list.product_code,
          product_name: this.list.product_name,
          unit_id: this.list.unit_id,
          unit_name: this.list.unit_name,
          unit_qty: this.list.unit_qty,
          quantity: this.quantity,
        };
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        await HTTP_ARIN.post(
          "/countstock/store/count/product/list",
          data,
          config
        ).then((res) => {
          if (res.data.successful === true) {
            this.alert_success = true;
            this.alert_message_success = "บันทึกการนับสต๊อกสำเร็จ";

            // ❌ เดิม: อาจจะไม่ได้เคลียร์ค่าเสมอ
            // this.quantity = null;
            // this.product_barcode = null;

            // ✅ วิธีแก้: ใช้ `$nextTick()` เพื่อให้ Vue รีเรนเดอร์ก่อน
            this.$nextTick(() => {
              this.quantity = null; // รีเซ็ตช่องจำนวน
              this.product_barcode = null; // รีเซ็ตช่อง barcode
              this.list = {}; // เคลียร์ข้อมูลสินค้า
              
              // 🎯 โฟกัสกลับไปที่ช่อง barcode
              if (this.$refs.barcodeInput) {
                this.$refs.barcodeInput.focus();
              }
            });

            // ให้ alert หายไปหลัง 1 วินาที
            setTimeout(() => {
              this.alert_success = false;
            }, 1000);
          }
        });
      }
    },
  },
  mounted() {
    this.getProductToSelectBox();
  },
};
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}
.theme--light.v-timeline:before {
  background-color: #d6bfaf;
  width: 4px;
}
/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}
.logo_timeline {
  width: 25px;
  height: 25px;
}
.logo_timeline > img {
  max-width: 25px;
}
.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}
.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}
.radio_half {
  display: grid;
  grid-template-columns: 50%;
}
.v-otp-input .v-input {
  padding: 10px !important;
}
.input-radius {
  border-radius: 10px;
}
.grid_radio {
  display: flex;
  justify-content: space-between;
}
.btn_width {
  width: 50%;
}
.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}
.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.mobile_btn {
  width: 15%;
}
.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}
.preview {
  border-radius: 10px;
}
.logo_admin {
  width: 80px;
  height: 80px;
}
.logo_admin > img {
  max-width: 80px;
}
.btn_width {
  width: 50%;
}
.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616a6b;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}

.font-bold {
  font-weight: bold !important;
}

.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.btn_detail_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #0f71b9 0%, rgba(136, 179, 88, 0) 100%),
    #8ebbdc !important;
  border-radius: 10px;
  width: 100%;
}

/* .btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100% !important;
} */
</style>
